import Vue from 'vue'
import domReady from '../utils/domReady.js'

domReady(() => {
  const el = document.querySelector('#notification')
  if (el !== null) {
    const vm = new Vue({
      delimiters: ['${', '}'],
      data: {
        show: false,
        key: null
      },
      methods: {
        hideNotification () {
          this.show = false
          localStorage[this.key] = true
        },
        showNotification () {
          this.show = true
          localStorage.removeItem(this.key)
        }
      },
      mounted () {
        this.key = el.dataset.key
        if (!localStorage[this.key]) {
          this.show = true
        }
      }
    })
    vm.$mount(el)
  }
})
